module.exports = __webpack_public_path__ + "media/images/aloe/icons/empty-cart-ebcaaea5f46d620a2491e8c5e184a065.svg";